<template>
  <div class="row">
    <div class="col">
      <w-select :model="schema.statusId" :values="values" />
    </div>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';
import { mapState } from 'vuex';

import { PublicSettings } from '@/enums/publicSettings.enum';

// @vuese
// Komponent dla listy BiK
// @group ActionData
export default {
  components,
  props: {
    schema: { type: Object, required: false }
  },
  computed: {
    ...mapState({
      statuses: state => state.setting.settings[PublicSettings.ARCHIVE_STATUSES]?.value
    }),
    values() {
      return (this.statuses && JSON.parse(this.statuses)) || [];
    }
  }
};
</script>
